import React from "react";
import { useNavigate } from "react-router-dom";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full w-full flex items-center justify-center">
      <div className=" w-full max-w-[1164px] min-h-screen overflow-hidden flex flex-col md:flex-row items-center justify-center p-4">
        {/* Left */}
        <div className="w-full md:w-1/2 p-8 flex items-center justify-center ">
          <svg
            width="220"
            height="220"
            viewBox="0 0 220 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            className="select-none"
          >
            <rect x="0" y="0" width="220" height="220" rx="20" fill="#F3F4F6" />
            <g transform="translate(50,50)">
              <circle cx="50" cy="50" r="40" fill="#E6F0FF" />
              <path d="M10 110 L90 110" stroke="#CBD5E1" strokeWidth="6" strokeLinecap="round" />
              <text x="50" y="60" textAnchor="middle" fontSize="28" fill="#1E3A8A" fontFamily="Inter, Arial">
                404
              </text>
            </g>
          </svg>
        </div>

        {/* Right: Content */}
        <div className="w-full md:w-1/2 flex items-center justify-center flex-col ">
          <h1 className="text-2xl md:text-5xl font-extrabold text-gray-900">Page not found</h1>

          <div className="w-full mt-5 sm:mt-10 flex items-start justify-center">
            <button
              onClick={() => navigate("/")}
              className="min-w-[220px] sm:min-w-[380px] inline-flex items-center justify-center px-5 py-2 rounded-2xl bg-primary text-white font-medium shadow-sm hover:brightness-95 transition"
            >
              Go to Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
